import React, { Fragment } from 'react';
import BackButton from '../../../components/Common/BackButton';

interface OnboardingSuccessProps {
  submit: () => void;
  skip: () => void;
  onBack: () => void;
}

const OnboardingStartTour: React.FC<OnboardingSuccessProps> = ({ submit, skip, onBack }) => {
  return (
    <>
      <div className="bg-white max-w-lg font-sofiaSans px-4 sm:px-0">
        <div className="text-start">
          <h2 className="text-2xl sm:text-3xl font-bold text-center text-black mb-4 sm:mb-5">
            <span className="mr-1">🎉</span>You're nearly set up!
          </h2>
          <div className="mt-2">
            <p className="text-sm text-secondaryStoryBlackText leading-relaxed mb-3">
              Want a quick tour of your portal? We’ll show you the basics so you’re ready to go. Takes under 2 minutes.
            </p>
          </div>
        </div>
      </div>
      <div className="w-full bg-white py-2 flex flex-row justify-between items-center gap-2 sm:gap-0 px-4 sm:px-0">
        <div>
          <BackButton onClick={onBack}></BackButton>
        </div>
        <div className="flex justify-end">
          <button
            onClick={skip}
            className="bg-transparent hover:underline text-black font-semibold py-2 rounded-full focus:outline-none w-auto flex items-center justify-center relative mr-6 sm:mr-8 text-sm sm:text-base"
          >
            Skip
          </button>
          <button
            className={`px-6 py-2 h-9 bg-secondaryStoryAdditionalLightBlueText text-whiteText font-bold leading-none rounded-2xl hover:shadow-md transition-shadow flex items-center justify-center text-sm sm:text-base w-auto`}
            onClick={() => submit()}
          >
            Start Tour
          </button>
        </div>
      </div>
    </>
  );
};

export default OnboardingStartTour;
